const bookPay = {
  'bank-card': 'Банковская карта',
  cash: 'Наличные средства',
  ivanytina: 'Иванютина',
  podgornov: 'Подгорнов',
  'ultimatum-shop': 'Магазин',
  'ultimatum-store': 'Сайт RU',
  'ultimatum-com': 'Сайт COM',
  onevision: 'Onevision',
  dolyamy: 'Долями',
  'payment-upon-receipt': 'При получении',
  'return-advance': 'Аванс',
  'endorsement-deposit': 'Ultimatum Select',
  none: 'Клиент',
  bonus: 'Бонусы',
  'ultimatum-crm': 'СRM',
  'ultimatum-sportmaster':'Спортмастер',
  'ultimatum-club':'Точка продаж',
  'ultimatum-ozon':'Ozon',
  'ultimatum-willdbires':'WB',

}

export {
  bookPay
}
